import { UAParser } from 'ua-parser-js';

export function formatUserAgent(userAgent: string) {
  if (!userAgent) {
    return '-';
  }
  const device = UAParser(userAgent);
  const browser = device?.browser;
  const osName = device?.os?.name;
  const cleanVersion = browser?.version
    ?.replace(/\.0$/, '')
    ?.replace(/\.0$/, '')
    ?.replace(/\.0$/, '');
  const browserPart = [browser?.name, cleanVersion].filter(Boolean).join(' ');

  if (!osName && !browserPart) {
    return '-';
  }
  return [osName, browserPart].filter(Boolean).join(' - ');
}

// export function parseCurrentUserAgent() {
//   const device = UAParser(window?.navigator.userAgent);
//   return device;
// }
